import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Maybe } from "@ispb/react-hooks";
import classNames from "classnames";
export default function ThumbnailIcon(props) {
    return (_jsx("div", { className: classNames("w-100 h-100 text-center d-flex align-items-center justify-content-center thumbnail-icon"), children: _jsxs("div", { children: [_jsx(FontAwesomeIcon, { ...props.icon, className: classNames(props.icon.className, "icon") }), _jsx(Maybe, { value: props.children, children: text => {
                        return (_jsx("div", { className: "text", children: text }));
                    } })] }) }));
}
